import { Reducer } from 'redux'
import {
  CombineFormActionTypes,
  type CombinedFormAction,
  type CombinedFormState,
  initialCombinedFormState,
} from './types'

export * from './types'

export const reducer: Reducer<CombinedFormState, CombinedFormAction> = (
  state = initialCombinedFormState,
  action
) => {
  switch (action.type) {
    case CombineFormActionTypes.SET_COMBINED_FORM_DATA: {
      return {
        ...state,
        ...action.payload, // merge updated data
      }
    }

    case CombineFormActionTypes.CLEAR_COMBINED_FORM_DATA: {
      return {
        ...initialCombinedFormState, // reset to initial values
      }
    }

    default:
      return state
  }
}
